import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
    },
  },
});

// Common - Queries

export const USER_STORE_KEY = "user";

export const LOAN_APPLICATIONS_STORE_KEY = "loan_applications";

export const CURRENT_LOAN_APPLICATION_STORE_KEY = "current_loan_application";

export const HAS_ONGOING_APPLICATION_STORE_KEY = "HAS_ONGOING_APPLICATION";

export const LENDER_RESPONSES_STORE_KEY = "lender_responses";

export const SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY =
  "selected_lender_response";

export const FIELD_REQUESTS_STORE_KEY = "field_requests";

export const ONE_FIELD_REQUEST_STORE_KEY = "field_request";

/**
 * Build the `[field_request, id]` key — never assemble it by hand.
 *
 * The id arrives as a string from some payloads and a number from others while
 * the type says `string`. React Query hashes with `JSON.stringify`, so
 * `["field_request", "10"]` and `["field_request", 10]` are separate entries —
 * an upload wrote one while every mounted form observed the other.
 */
export const oneFieldRequestQueryKey = (
  fieldRequestID?: string | number,
): [string, string | undefined] => [
  ONE_FIELD_REQUEST_STORE_KEY,
  fieldRequestID == null ? undefined : String(fieldRequestID),
];

export const DELEGATED_FIELD_REQUESTS_STORE_KEY = "delegated_field_requests";

// Common - Mutations
export const POST_FIELD_REQUEST_STORE_KEY = "post_field_request";

export const DELETE_FIELD_REQUEST_FILE_STORE_KEY = "delete_field_request_file";

export const SUBMIT_APPLICATION_STORE_KEY = "submit_application";

export const REJECT_APPLICATION_AS_CUSTOMER_STORE_KEY =
  "reject_application_as_customer";

export const CONTACT_CUSTOMER_SERVICE_STORE_KEY = "contact_customer_service";

// Customer Web - Queries
export const IDENTIFY_CUSTOMER_STORE_KEY = "identify_customer";

export const UPDATE_CONTACT_DETAILS_STORE_KEY = "update_contact_details";

export const EXTENDED_REPAYMENT_PLAN_STORE_KEY = "extended_repayment_plan";

// Partner Web - Queries
export const COLLECT_LOAN_APPLICATION_STORE_KEY = "collect_loan_application";

export const PAYOUTS_STORE_KEY = "payouts";

export const WHITELIST_DATA_STORE_KEY = "whitelist_data";

// CMS - Query
export const CMS_SITE_SETTINGS_STORE_KEY = "cms_site_settings";
